export enum AnnualIncomeRange {    
    NoAnswer = 0,
    Range0To16 = 1,
    Range16To26 = 2,
    Range26To36 = 3,
    Range36To47 = 4,
    Range47To62 = 5,
    Range62To83 = 6,
    Range83To104 = 7,
    RangeAbove104 = 8
}